import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-charcoal">
      <Header />

      {/* Top "manuscript line" — a slim gold rule that sweeps across on every navigation */}
      <motion.div
        key={`sweep-${location.pathname}`}
        initial={{ scaleX: 0, transformOrigin: "0% 50%" }}
        animate={{ scaleX: 1, transformOrigin: "0% 50%" }}
        exit={{ scaleX: 0, transformOrigin: "100% 50%" }}
        transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
        className="fixed top-20 left-0 right-0 h-[2px] bg-gold z-40 pointer-events-none"
        aria-hidden="true"
      />

      <main className="flex-1">
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{
              duration: 0.55,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}
